import { render } from "./StarsNotation.component.vue?vue&type=template&id=08cb318f"
import script from "./StarsNotation.component.vue?vue&type=script&lang=js"
export * from "./StarsNotation.component.vue?vue&type=script&lang=js"

import "./StarsNotation.component.vue?vue&type=style&index=0&id=08cb318f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
